// Component not used yet - 05/19/2021
import { Checkbox, CheckboxVisibility, ConstrainMode, IColumn, MessageBar, MessageBarType, SelectionMode, ShimmeredDetailsList, Stack } from '@fluentui/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/types';
import { Payer } from '../../redux/visits/types';

export const MarketPayers = () => {
  const payers = useSelector((state: RootState) => state.visits.visitConfig.data?.payers || []);

  const columns: IColumn[] = [
    {
      key: 'name',
      name: 'Name',
      fieldName: 'shortName',
      minWidth: 120,
      maxWidth: 180,
      isResizable: true,
    },
    {
      key: 'code',
      name: 'Payer Code',
      fieldName: 'eligiblePayerCode',
      minWidth: 90,
      maxWidth: 100,
    },
    {
      key: 'id',
      name: 'ID',
      fieldName: 'id',
      minWidth: 120,
      maxWidth: 280,
    },
    {
      key: 'address',
      name: 'Address',
      fieldName: 'address',
      minWidth: 140,
      maxWidth: 240,
      isResizable: true,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onRender: (item: Payer) => {
        return (
          <Stack>
            {/* Commenting out as payer does not return these properties
            <div>{item.billingAddress1}</div>
            {item.billingAddress2 && <div>{item.billingAddress2}</div>}
            <div>{`${item.billingCity}, ${item.billingZipcode}, ${item.billingState}`}</div>*/}
          </Stack>
        );
      },
    },
    {
      key: 'requestGroupId',
      name: 'GroupId Required',
      fieldName: 'requestGroupId',
      minWidth: 160,
      maxWidth: 160,
      onRender: (item: Payer) => {
        return <Checkbox disabled={true} checked={item?.requestGroupId} />;
      },
    },
    {
      key: 'enabled',
      name: 'Enabled',
      fieldName: 'enabled',
      minWidth: 60,
      maxWidth: 60,
      onRender: () => {
        // TODO: support
        return <Checkbox checked={false} />;
      },
    },
  ];

  return (
    <>
      <MessageBar messageBarType={MessageBarType.warning}>This is read-only at this time - updates have not been implemented yet.</MessageBar>
      <ShimmeredDetailsList
        enableShimmer={false}
        shimmerLines={8}
        selectionMode={SelectionMode.none}
        constrainMode={ConstrainMode.horizontalConstrained}
        checkboxVisibility={CheckboxVisibility.hidden}
        items={payers}
        setKey="set"
        columns={columns}
      />
    </>
  );
};
